module.exports = __webpack_public_path__ + "static/img/xl.11919bb1.jpg";